import { useSnackbar, OptionsObject, ProviderContext } from 'notistack';
import { FC, ReactNode } from 'react';

export enum VariantType {
  default = 'default',
  error = 'error',
  success = 'success',
  warning = 'warning',
  info = 'info',
}

interface SnackProps {
  setUseSnackbarRef: (showSnackbar: ProviderContext) => void;
  children?: ReactNode;
}

const InnerSnackbarConfigurator: FC<SnackProps> = (props) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: ProviderContext;
const setUseSnackbarRef = (useSnackbarRefProp: ProviderContext) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarConfigurator = (props: { children?: ReactNode }) => {
  return (
    <InnerSnackbarConfigurator setUseSnackbarRef={setUseSnackbarRef}>
      {props.children}
    </InnerSnackbarConfigurator>
  );
};

export default {
  success(msg: string, options: OptionsObject = {}) {
    this.toast(msg, { ...options, variant: VariantType.success });
  },
  warning(msg: string, options: OptionsObject = {}) {
    this.toast(msg, { ...options, variant: VariantType.warning });
  },
  info(msg: string, options: OptionsObject = {}) {
    this.toast(msg, { ...options, variant: VariantType.info });
  },
  error(msg: string, options: OptionsObject = {}) {
    this.toast(msg, { ...options, variant: VariantType.error });
  },
  toast(msg: string, options: OptionsObject = {}) {
    useSnackbarRef.enqueueSnackbar(msg, options);
  },
};
